import { Outlet } from "react-router";
import Header from "../layout/header";
import useNav from "../../script/tabingNavArray";


const NotificationLayout = () => {
    const navList = useNav();
    let { notificationBottomNav, topNotificationNav } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={notificationBottomNav} topTabs={topNotificationNav} />
            <Outlet />
        </div>
    )
}

export default NotificationLayout;